<p>pim-create-model-modal works!</p>
